import {$clientApi} from "../http";
import {ICoupon, ICouponError} from "../models/Coupon";

class CouponServiceClass {

    async getSubscriptionActiveCoupons(couponCode: string, scope: "subscription" | "dropIn" | "appointment") {
        return $clientApi.get<ICoupon | ICouponError>(`api/coupons/coupon?couponCode=${couponCode}&scope=${scope}`);
    }

}

export const CouponService = new CouponServiceClass();